import { StyleSheet, Font } from "@react-pdf/renderer";

Font.register({
  family: "Helvetica Neue",
  fonts: [
    {
      src: "https://fonts.cdnfonts.com/s/29136/HelveticaNeueBold.woff",
    },
    {
      src: "https://fonts.cdnfonts.com/s/29136/Helvetica45Light_22437.woff",
      fontWeight: 300,
    },
  ],
});

/**
 * Styles for the PDF file.
 */
const styles = StyleSheet.create({
  // Shared
  page: {
    fontSize: "10px",
    lineHeight: "1.2",
    padding: "61px 65px",
    border: "1px solid #707070",
  },
  landscape: {
    padding: "30.5px 32.5px",
  },
  section: {
    marginBottom: "30px",
  },
  header: {
    paddingBottom: "6.5px",
    borderBottom: "1px solid #707070",
    marginBottom: "6.5px",
  },
  "item-header": {
    marginBottom: "3px",
  },
  "info-text": {
    opacity: "0.8",
  },
  bold: {
    fontFamily: "Helvetica Neue",
    fontWeight: "bold",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "column-flex": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // padding: "0 3px",
  },
  // Event Center
  "event-center-header": {
    marginBottom: "6.5px",
  },
  "event-center-flex": {
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  "event-center-item": {
    minWidth: "27.5%",
  },
  "event-center-margin": {
    marginBottom: "16px",
  },
  // Table
  "table-header": {
    marginTop: "7px",
    opacity: "1",
    fontFamily: "Helvetica Neue",
    fontWeight: "normal",
  },
  "grey-row": {
    backgroundColor: "#EBEBEB",
    opacity: "0.6",
  },
  cell: {
    width: "25%",
    padding: "10px",
  },
  // Locations
  location: {
    color: "rgb(244, 197, 121)",
    textDecoration: "underline",
    marginRight: "auto",
    paddingLeft: "9px",
  },
  // Circumstances
  circumstances: {
    marginTop: "6.5px",
    color: "#707070",
  },
  // Staff
  "list-cell": {
    width: "22.5%",
  },
  pin: {
    padding: "12px",
    width: "10%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  unchecked: {
    border: "1px solid #EBEBEB",
    height: "10px",
    width: "10px",
  },
  // Incidents
  incident: {
    padding: "6px 8px 7px",
    width: "15%",
    flexGrow: 1,
  },
  light: {
    fontWeight: 300,
  },
  number: {
    color: "#1F3BD8",
    textDecoration: "underline",
  },
  shrink: {
    width: "10%",
  },
});

export default styles;
